import Map from './Map';
import './Map.scss';

export default Map;
